import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from ".././Header/AuthContext";
import Header from ".././Header/Header";
import Footer from ".././Header/Footer";
import Config from ".././Header/Config";
import Navbar from ".././Header/Navbar";
import axios from "axios";
import { FaFilePdf } from "react-icons/fa";
import { exportFilteredToPDF } from "../../utils/pdfExport";
function Today_profit() {
  const username = localStorage.getItem("username");
  const today = new Date().toISOString().split("T")[0];

  //  .........................Buyback Details......................
  const [todaysPurchase, settodaysPurchase] = useState(0);
  const [todaysSell, settodaysSell] = useState(0);
  const [todaysProfit, settodaysProfit] = useState(0);

  //  .........................Last 30 Days Data......................
  const [last30DaysData, setLast30DaysData] = useState([]);
  const [isLoading30Days, setIsLoading30Days] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  
  //  .........................Model Wise Profit Data......................
  const [expandedRows, setExpandedRows] = useState(new Set());




  const apiUrl = Config.apiUrl;
  // const fetchData = useCallback(async () => {
  //   try {
  //     //  .........................sell Details......................

  //     const profitresponse = await axios.get(`${apiUrl}/getSellsDetails`);
  //     console.log(profitresponse)
  //     settodaysPurchase(profitresponse.data.todaysPurchase)
  //     settodaysSell(profitresponse.data.todaysSell)
  //     settodaysProfit(profitresponse.data.todaysProfit)




  //   } catch (error) {
  //     console.error(error);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  //  .........................Fetch Last 30 Days Data......................
  const fetchLast30DaysData = useCallback(async () => {
    setIsLoading30Days(true);
    try {
      const response = await axios.post(`${apiUrl}/getProfitLoss`, {
        date1: fromDate || "",
        date2: toDate || "",
      });
      console.log("Last 30 Days Profit Response:", response);
      setLast30DaysData(response.data.data || []);
      settodaysPurchase(response.data.today_purchase_amount)
      settodaysSell(response.data.today_sale_amount)
      settodaysProfit(response.data.today_profit)
    } catch (error) {
      console.error("Error fetching last 30 days data:", error);
      setLast30DaysData([]);
    } finally {
      setIsLoading30Days(false);
    }
  }, [apiUrl, fromDate, toDate]);

  useEffect(() => {
    fetchLast30DaysData();
  }, [fetchLast30DaysData]);

  //  .........................Toggle Row Expand/Collapse......................
  const toggleRow = (date) => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(date)) {
      newExpandedRows.delete(date);
    } else {
      newExpandedRows.add(date);
    }
    setExpandedRows(newExpandedRows);
  };

  //  .........................Format Number with Commas......................
  const formatNumber = (value) => {
    if (!value && value !== 0) return "0.00";
    const num = parseFloat(value) || 0;
    return num.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  //  .........................PDF Export Handler......................
  const handleExportToPDF = () => {
    if (!last30DaysData || last30DaysData.length === 0) {
      alert('No data to export');
      return;
    }

    // Prepare data for PDF export (flatten with model details)
    const pdfData = [];
    
    last30DaysData.forEach((item) => {
      // Add main row
      pdfData.push({
        date: item.date || "-",
        purchase_amount: item.total_purchase || "0",
        sell_amount: item.total_sales || "0",
        profit: item.profit || "0",
        model_name: "-",
        imei: "-",
        is_total: true
      });

      // Add model-wise rows if available
      if (item.models && Array.isArray(item.models) && item.models.length > 0) {
        item.models.forEach((model) => {
          const modelNameWithImei = model.imei 
            ? `${model.model_name || "-"} (IMEI: ${model.imei})`
            : (model.model_name || "-");
          pdfData.push({
            date: model.date || item.date || "-",
            purchase_amount: model.total_purchase || "0",
            sell_amount: model.total_sales || "0",
            profit: model.profit || "0",
            model_name: modelNameWithImei,
            is_total: false
          });
        });
      }
    });

    const columns = [
      { key: 'date', label: 'Date' },
      { key: 'model_name', label: 'Model Name' },
      { key: 'purchase_amount', label: 'Purchase Amount' },
      { key: 'sell_amount', label: 'Sell Amount' },
      { key: 'profit', label: 'Profit' },
    ];

    const fileName = `ProfitReport_${fromDate || 'All'}_${toDate || 'All'}`;
    exportFilteredToPDF(pdfData, columns, fileName);
  };

  return (

    <>
      <>
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">

            <Header />

            <div className="layout-page">
              <Navbar />
              <div className="content-wrapper">
                {/* Content */}
                <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="text-nowrap mb-2">
                                  Today's Profit
                                </h4><br></br>
                  <div className="row">
                    {/* Order Statistics */}
                    <div className="col-md-6 col-lg-4 col-xl-4 order-0 mb-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                            <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                              <div className="card-title">
                                <h5 className="text-nowrap mb-2">
                                  Purchase Amount
                                </h5>
                                {/* <span className="badge bg-label-warning rounded-pill">
                                Year 2021
                              </span> */}
                              </div>
                              <div className="mt-sm-auto">

                                <h3 className="mb-0">{todaysPurchase}</h3>
                              </div>
                            </div>
                            <div id="profileReportChart" />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*/ Order Statistics */}
                    {/* Expense Overview */}
                    <div className="col-md-6 col-lg-4 col-xl-4 order-0 mb-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                            <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                              <div className="card-title">
                                <h5 className="text-nowrap mb-2">
                                  Sell Amount
                                </h5>
                                {/* <span className="badge bg-label-warning rounded-pill">
                                Year 2021
                              </span> */}
                              </div>
                              <div className="mt-sm-auto">

                                <h3 className="mb-0">{todaysSell}</h3>
                              </div>
                            </div>
                            <div id="profileReportChart" />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*/ Expense Overview */}
                    {/* Transactions */}
                    <div className="col-lg-4 col-md-4 order-1">

                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between flex-sm-row flex-column gap-3">
                            <div className="d-flex flex-sm-column flex-row align-items-start justify-content-between">
                              <div className="card-title">
                                <h5 className="text-nowrap mb-2">
                                  Today's Profit
                                </h5>
                                {/* <span className="badge bg-label-warning rounded-pill">
                                Year 2021
                              </span> */}
                              </div>
                              <div className="mt-sm-auto">

                                <h3 className="mb-0">{todaysProfit}</h3>
                              </div>
                            </div>
                            <div id="profileReportChart" />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*/ Transactions */}
                  </div>

                  {/* Last 30 Days Profit Table */}
                  <div className="row mt-4">
                    <div className="col-12">
                      {/* Date Filter */}
                      <div className="row mb-3">
                        <div className="col-md-5"></div>
                        <div className="col-md-7">
                          <div className="row align-items-end">
                            <div className="form-group col-md-4 mb-0">
                              <label className="form-label" htmlFor="from-date">
                                From
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id="from-date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                              />
                            </div>
                            <div className="form-group col-md-4 mb-0">
                              <label className="form-label" htmlFor="to-date">
                                To
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id="to-date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                max={today}
                              />
                            </div>
                            <div className="form-group col-md-4 mb-0">
                              <label className="form-label">&nbsp;</label>
                              <button
                                className="btn btn-danger w-100"
                                onClick={handleExportToPDF}
                                disabled={!last30DaysData || last30DaysData.length === 0}
                                title="Export to PDF"
                                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}
                              >
                                <FaFilePdf />
                                PDF Export
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* / Date Filter */}
                      <div className="card">
                        <h5 className="card-header">Last 30 Days Profit</h5>
                        <div
                          className="table-responsive text-nowrap"
                          style={{ overflowY: "auto", maxHeight: "600px" }}
                        >
                          {isLoading30Days ? (
                            <div className="d-flex justify-content-center mb-5">
                              <div className="spinner-border text-primary" role="status">
                                <span className="sr-only"></span>
                              </div>
                            </div>
                          ) : (
                            <table className="table">
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                  backgroundColor: "#f5f5f5",
                                }}
                              >
                                 <tr className="text-nowrap">
                                   <th style={{ width: "80px", textAlign: "center" }}>Action</th>
                                   <th>SN</th>
                                   <th>Date</th>
                                   <th>Purchase Amount</th>
                                   <th>Sell Amount</th>
                                   <th>Profit</th>
                                 </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(last30DaysData) &&
                                last30DaysData.length > 0 ? (
                                  last30DaysData.map((item, index) => {
                                    const date = item.date || "";
                                    const isExpanded = expandedRows.has(date);
                                    const modelData = item.models || [];
                                    
                                    return (
                                      <React.Fragment key={index}>
                                        <tr style={{ backgroundColor: isExpanded ? "#f8f9fa" : "inherit" }}>
                                          <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                            {date && (
                                              <button
                                                className={`btn btn-sm ${isExpanded ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => toggleRow(date)}
                                                style={{
                                                  minWidth: "36px",
                                                  height: "36px",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  padding: 0,
                                                }}
                                                title={isExpanded ? "Click to collapse" : "Click to view model wise profit"}
                                              >
                                                {isExpanded ? (
                                                  <i className="bx bx-chevron-down" style={{ fontSize: "20px" }}></i>
                                                ) : (
                                                  <i className="bx bx-chevron-right" style={{ fontSize: "20px" }}></i>
                                                )}
                                              </button>
                                            )}
                                          </td>
                                          <td>{index + 1}</td>
                                          <td>{date || "-"}</td>
                                          <td>{item.total_purchase || "0"}</td>
                                          <td>{item.total_sales || "0"}</td>
                                          <td>{item.profit || "0"}</td>
                                        </tr>
                                        {isExpanded && (
                                          <tr>
                                            <td colSpan="6" style={{ padding: 0 }}>
                                              <div style={{ padding: "15px", backgroundColor: "#f8f9fa" }}>
                                                <h6 className="mb-3" style={{ fontWeight: "600" }}>
                                                  Model Wise Profit - {date}
                                                </h6>
                                                {Array.isArray(modelData) && modelData.length > 0 ? (
                                                  <div className="table-responsive">
                                                    <table className="table table-sm table-bordered" style={{ backgroundColor: "white" }}>
                                                      <thead style={{ backgroundColor: "#e9ecef" }}>
                                                        <tr>
                                                          <th>SN</th>
                                                          <th>Model Name</th>
                                                          <th>Purchase Amount</th>
                                                          <th>Sell Amount</th>
                                                          <th>Profit</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {modelData.map((modelItem, modelIndex) => (
                                                          <tr key={modelIndex}>
                                                            <td>{modelIndex + 1}</td>
                                                            <td>
                                                              {modelItem.model_name || "-"}
                                                              {modelItem.imei && (
                                                                <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "2px" }}>
                                                                  IMEI: {modelItem.imei}
                                                                </div>
                                                              )}
                                                            </td>
                                                            <td>{modelItem.purchase_price || "0"}</td>
                                                            <td>{modelItem.sale_price || "0"}</td>
                                                            <td>{modelItem.profit || "0"}</td>
                                                          </tr>
                                                        ))}
                                                      </tbody>
                                                      <tfoot style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                                                        <tr>
                                                          <td colSpan="2">Total</td>
                                                          <td>
                                                            {modelData.reduce((sum, item) => 
                                                              sum + parseFloat(item.purchase_price || 0), 0
                                                            ).toFixed(2)}
                                                          </td>
                                                          <td>
                                                            {modelData.reduce((sum, item) => 
                                                              sum + parseFloat(item.sale_price || 0), 0
                                                            ).toFixed(2)}
                                                          </td>
                                                          <td>
                                                            {modelData.reduce((sum, item) => 
                                                              sum + parseFloat(item.profit || 0), 0
                                                            ).toFixed(2)}
                                                          </td>
                                                        </tr>
                                                      </tfoot>
                                                    </table>
                                                  </div>
                                                ) : (
                                                  <div className="text-center py-3 text-muted">
                                                    No model wise data available for this date
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="6">No data available</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* / Last 30 Days Profit Table */}

                </div>
                {/* / Content */}
                {/* Footer */}
                <Footer />
                {/* / Footer */}
                <div className="content-backdrop fade" />
              </div>
              {/* Content wrapper */}
            </div>
            {/* / Layout page */}
          </div>
          {/* Overlay */}
          <div className="layout-overlay layout-menu-toggle" />
        </div>
        {/* / Layout wrapper */}

      </>

    </>
  );
}

export default Today_profit;